import { render, staticRenderFns } from "./BFormCheckboxRadio.vue?vue&type=template&id=4094791a&scoped=true&"
import script from "./BFormCheckboxRadio.vue?vue&type=script&lang=js&"
export * from "./BFormCheckboxRadio.vue?vue&type=script&lang=js&"
import style0 from "./BFormCheckboxRadio.vue?vue&type=style&index=0&id=4094791a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094791a",
  null
  
)

export default component.exports